import { LensModel } from "../../lens-details/models/LensModel";
import { VendorDataCollection } from "../../../vendor-data/models";
import { type GetLensV2Query } from "../../api/query";
import { BaseModel } from "../../../core/models";
import { type ComSnapCamerakitAdminV2VendorDataItem } from "../../../../gql-generated/camkit-types";
import { type LensCompoundIdModel } from "../../models";
import { DateConvert } from "./DateConvert";

export const LensService = {
    createFromLens(lens: NonNullable<GetLensV2Query["getLensV2"]>["lens"] | undefined) {
        return BaseModel.createInstance(LensModel, {
            // Service LensCompoundId and the hand-written LensCompoundIdModel are shape-compatible;
            // cast through unknown to drop the extra __typename field.
            compoundId: (lens?.compoundId ?? undefined) as unknown as LensCompoundIdModel | undefined,
            name: lens?.name,
            iconUrl: lens?.iconUrl,
            previewUrl: lens?.previewUrl,
            lensSource: lens?.lensSourceInfo?.name ?? undefined,
            // vendor-data module still typed against the un-migrated (proto) VendorDataItem
            // alias. Shape matches; cast through unknown until the cleanup PR flips it.
            vendorData: new VendorDataCollection(
                (lens?.vendorData?.flatMap((vendorData) => (vendorData == null ? [] : [vendorData])) ??
                    []) as unknown as readonly ComSnapCamerakitAdminV2VendorDataItem[],
            ),
            updatedAt: lens?.updatedAt ? DateConvert.toDate(lens.updatedAt) : null,
            hasMusic: lens?.hasMusic ?? undefined,
            videoUrl: lens?.videoUrl ?? undefined,
        });
    },
};
